<template>
  <table class="unstriped hover boss-table">
    <thead>
      <tr>
        <th class="boss-table-head-center">
          求人ID
        </th>
        <th class="boss-table-head-center">
          管理用求人名
        </th>
        <th class="boss-table-head-center">
          求人名
        </th>
        <th class="boss-table-head-center">
          掲載サイズ
        </th>
        <th class="boss-table-head-center">
          求人プレビュー
        </th>
        <th class="boss-table-head-center">
          オプション情報プレビュー
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-if="isExistJobs">
        <job-pre-published-job
          v-for="(job, i) in jobs"
          :key="i"
          :job="job"
          :is-show-options="isShowOptions(job.id)"
          :photoclip-ids="photoclipIds"
          :interview-ids="interviewIds"
          :options-rowspan="jobs.length"
          :data-test="`job-pre-published-job-${i}`"
        />
      </template>
      <template v-else>
        <template v-if="isExistOptions">
          <tr>
            <td class="boss-table-data" />
            <td class="boss-table-data" />
            <td class="boss-table-data" />
            <td class="boss-table-data" />
            <td class="boss-table-data" />
            <job-pre-published-option-sell
              :rowspan="1"
              :photoclip-ids="photoclipIds"
              :interview-ids="interviewIds"
            />
          </tr>
        </template>
        <template v-else>
          <tr>
            <td
              colspan="6"
              data-test="jobs-no-data"
            >
              ※掲載前確認中の求人やオプション情報はありません
            </td>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>

<script>
import JobPrePublishedJob from '@/components/molecules/JobPrePublishedJob'
import JobPrePublishedOptionSell from '@/components/atoms/JobPrePublishedOptionSell'
import _ from 'lodash'

export default {
  components: {
    JobPrePublishedJob,
    JobPrePublishedOptionSell
  },
  props: {
    jobs: {
      type: Array,
      required: true
    },
    photoclipIds: {
      type: Array,
      required: true
    },
    interviewIds: {
      type: Array,
      required: true
    }
  },
  computed: {
    isExistJobs () {
      return !_.isEmpty(this.jobs)
    },
    isExistOptions  () {
      return !_.isEmpty(this.photoclipIds) || !_.isEmpty(this.interviewIds)
    }
  },
  methods: {
    isShowOptions (jobId) {
      // オプション情報はセル結合しているため求人の1列目のみに表示するため、先頭の求人IDと一致した場合のみtrue
      return jobId === _.head(this.jobs).id
    }
  }
}
</script>
